import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import { Reveal } from "../components/common/Reveal";
import WhyAmvi from "../components/home/WhyAmvi";
import CTASection from "../components/common/CTASection";
import PillButton from "../components/common/PillButton";

const blocks = [
  {
    title: "Our Mission",
    body: "To help organizations solve complex technology and workforce challenges through modern technology solutions and specialized talent. We bridge innovation and execution so ambition becomes measurable outcomes.",
  },
  {
    title: "Our Approach",
    body: "We combine deep technical expertise with specialized talent, aligned to the way your industry actually works. We prioritize responsiveness, transparency and long-term partnership over one-time transactions.",
  },
  {
    title: "Our Capabilities",
    body: "AI and machine learning, data engineering and analytics, cloud and DevOps, enterprise application development, engineering solutions, and IT and professional staffing — delivered as a single, integrated partner.",
  },
];

export default function About() {
  return (
    <>
      <SEO
        title="About AMVI Technologies"
        description="AMVI Technologies combines technology consulting, engineering expertise and specialized talent solutions to help organizations build, modernize and scale."
        path="/about"
      />
      <PageHero
        eyebrow="About"
        title="Technology Expertise. Human Partnership."
        subtitle="AMVI combines technology consulting, digital transformation, engineering expertise and specialized talent to help organizations build, modernize and scale."
        image="https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      >
        <PillButton to="/contact" size="lg">Talk to an Expert</PillButton>
      </PageHero>

      <section className="px-6 py-16 lg:py-24">
        <div className="mx-auto grid max-w-7xl gap-6 lg:grid-cols-3">
          {blocks.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-white/10 bg-ink-800/50 p-8">
                <span className="font-heading text-4xl font-bold text-sky-400/25">0{i + 1}</span>
                <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-white">{b.title}</h2>
                <p className="mt-4 text-base leading-relaxed text-slate-400">{b.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <div className="border-t border-white/5">
        <WhyAmvi />
      </div>

      <CTASection />
    </>
  );
}
